<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Verify Document</title>
    <link rel="stylesheet" href="styles.css">
</head>

<body>

    <div class="container">
        <div class="upload-container">
            <h2>PDF Document Verification</h2>
            <p class="description">Upload a PDF document to verify its correctness</p>

            <div class="upload-area" [class.drag-over]="isDragOver" (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

                <div *ngIf="!selectedFile && !isUploading" class="upload-prompt">
                    <i class="material-icons">cloud_upload</i>
                    <p>Drag and drop your PDF here or</p>
                    <label for="file-upload" class="upload-btn">Browse Files</label>
                    <input id="file-upload" type="file" accept=".pdf" (change)="onFileSelected($event)" hidden>
                </div>

                <div *ngIf="selectedFile && !isUploading" class="file-selected">
                    <i class="material-icons">description</i>
                    <p>{{ selectedFile.name }}</p>
                    <div class="file-actions">
                        <button class="verify-btn" (click)="verifyDocument()">Verify Document</button>
                        <button class="remove-btn" (click)="removeFile()">Remove</button>
                    </div>
                </div>

                <div *ngIf="isUploading" class="uploading">
                    <div class="spinner"></div>
                    <p>Verifying document...</p>
                </div>
            </div>

            <div *ngIf="verificationResult !== null" class="result-container" [class.success]="verificationResult === 0"
                [class.failure]="verificationResult !== 0">
                <i *ngIf="verificationResult === 0" class="material-icons">check_circle</i>
                <i *ngIf="verificationResult !== 0" class="material-icons">error</i>
                <h3 *ngIf="verificationResult === 0">Verification Successful!</h3>
                <h3 *ngIf="verificationResult !== 0">Verification Failed</h3>
                <p *ngIf="verificationResult === 0">The document has passed verification checks.</p>
                <p *ngIf="verificationResult !== 0">The document failed verification with error code: {{
                    verificationResult }}</p>
            </div>
        </div>
    </div>

</body>

</html>